
export const encryptObject = (object) => {
    return btoa(JSON.stringify(object));
};
